interface IAdmin {
  post: {
    balance: string;
    card: string;
    accountReset: string;
    energyReset: string;
  };
}

interface IAuth {
  get: {
    loginByNier: string;
  };
  post: {
    refreshToken: string;
    logout: string;
  };
}

interface IAccount {
  get: {
    accountInfo: string;
  };
}
interface ICharacter {
  get: {
    characterList: string;
  };
  post: {
    slot: string;
    skill: string;
    energyReplenishment: string;
    expirenceReplenishment: string;
    // skill: {
    //   redetermine: string;
    // };
    // slot: {
    //   unlock: string;
    //   fill: string;
    //   freeUp: string;
    // };
  };
}
interface ITutorial {
  post: {
    markStep: string;
  };
}
interface IConfiguration {
  get: {
    configuration: string;
  };
}

interface ICard {
  get: {
    cardState: string;
  };
}

interface ICity {
  get: {
    city: string;
  };
}

interface IBuildingCraft {
  post: {
    startCraft: string;
    collect: string;
    accelerate: string;
  };
}
interface IBuildingEnergyCraft {
  post: {
    startCraft: string;
  };
}
interface IGlobalMap {
  post: {
    matrix: string;
    unlock: string;
  };
}
interface IDailyQuestEndpoints {
  post: {
    dailyQuestAction: string;
  };
}

interface IFoodOrderEndpoints {
  post: {
    fetch: string;
    execute: string;
    cancel: string;
  };
}

interface IBuildingBarmanOfferEndpoints {
  post: {
    getOffers: string;
    buyDishes: string;
  };
}

interface IReferral {
  get: {
    referral: string;
  };
}
interface IFoodChallenges {
  post: {
    fetch: string;
    execute: string;
  };
  get: {
    history: string;
  };
}

interface IBackpack {
  get: {
    fetch: string;
  };
}

interface IStore {
  post: {
    buy: string;
  };
}

interface IExchanger {
  post: {
    exchange: {
      fetch: string;
      execute: string;
    };
    offer: {
      fetch: string;
      execute: string;
    };
  };
}

export const adminEndpoints: IAdmin = {
  post: {
    balance: 'admin/balance',
    card: 'admin/card',
    accountReset: 'admin/account/reset',
    energyReset: 'admin/character/energy/reset',
  },
};

export const checkApiHealthStatusEndpoint: string = 'health-check';

export const exchangerEndpoints: IExchanger = {
  post: {
    exchange: {
      fetch: 'building/exchanger/exchange/recipe/fetch',
      execute: 'building/exchanger/exchange/execute',
    },
    offer: {
      fetch: 'building/exchanger/offer/fetch',
      execute: 'building/exchanger/offer/fetch',
    },
  },
};

export const calculateNearToFishDolarCurrencyEndpoint: string =
  'currency/ratio/calculate/';

export const openMysteryBoxEndpoint: string = 'mystery/box/open';

export const fetchRecipyChance: string =
  'building/craft/resource/recipe/chance/fetch';

export const tutorialEndpoints: ITutorial = {
  post: {
    markStep: 'tutorial/step/mark',
  },
};
export const lotteryExecuteEndpoint: string = 'building/lottery/execute';

export const authEndpoints: IAuth = {
  get: {
    loginByNier: 'authentication/near/login',
  },
  post: {
    refreshToken: 'authentication/refresh/',
    logout: 'authentication/logout',
  },
};

export const accountEndpoints: IAccount = {
  get: {
    accountInfo: 'state/account',
  },
};

export const characterEndpoints: ICharacter = {
  get: {
    characterList: 'state/character',
  },
  post: {
    slot: 'character/slot/',
    skill: 'character/slot/skill/',
    energyReplenishment: 'character/energy/replenishment',
    expirenceReplenishment: 'character/experience/replenishment',
    // skill: {
    //   redetermine: 'character/slot/skill/redetermine',
    // },
    // slot: {
    //   unlock: 'character/slot/unlock',
    //   fill: 'character/slot/fill',
    //   freeUp: 'character/slot/free-up',
    // },
  },
};

export const configurationEndpoints: IConfiguration = {
  get: {
    configuration: 'state/configuration',
  },
};

export const cardEndpoints: ICard = {
  get: {
    cardState: 'state/card',
  },
};

export const cityEndpoints: ICity = {
  get: {
    city: 'state/city/',
  },
};

export const buildingCraftEndpoints: IBuildingCraft = {
  post: {
    startCraft: 'building/craft/resource/start',
    collect: 'building/craft/resource/collect',
    accelerate: 'building/craft/resource/accelerate',
  },
};
export const buildingEnergyCraftEndpoints: IBuildingEnergyCraft = {
  post: {
    startCraft: 'building/craft/energy/start',
  },
};
export const dailyQuestEndpoints: IDailyQuestEndpoints = {
  post: {
    dailyQuestAction: 'building/task/daily/',
  },
};
export const buildingBarmanOfferEndpoints: IBuildingBarmanOfferEndpoints = {
  post: {
    buyDishes: 'building/barman/offer/execute',
    getOffers: 'building/barman/offer/fetch',
  },
};
export const foodOrderEndpoints: IFoodOrderEndpoints = {
  post: {
    fetch: 'building/trading/order/fetch',
    execute: 'building/trading/order/execute',
    cancel: 'building/trading/order/cancel',
  },
};

export const foodChallengesEndpoints: IFoodChallenges = {
  post: {
    fetch: 'building/trading/challenge/fetch',
    execute: 'building/trading/challenge/execute',
  },
  get: {
    history: 'building/trading/challenge/history/fetch?page=0&size=100',
  },
};

export const backpackEndpoints: IBackpack = {
  get: {
    fetch: 'backpack/card/fetch',
  },
};

export const globalMapEndpoints: IGlobalMap = {
  post: {
    matrix: 'map/land/matrix',
    unlock: 'map/land/unlock',
  },
};
export const referralEndpoints: IReferral = {
  get: {
    referral: 'state/referral',
  },
};
export const storeEndpoints: IStore = {
  post: {
    buy: 'store/pack/buy',
  },
};
